import React from 'react'
import PropTypes from 'prop-types'
import { About } from '../../About'
import MobileRechargeScheduleInfo from './MobileRechargeScheduleInfo'

const AboutMobileRechargeSchedule = props => (
  <About title='Sobre o pedido'>
    <MobileRechargeScheduleInfo
      dateCreatedScheduling={props.dateCreatedScheduling}
      operator={props.operator}
      phoneNumber={props.phoneNumber}
      creditValue={props.creditValue}
      pointValue={props.pointValue}
    />
  </About>
)

AboutMobileRechargeSchedule.propTypes = {
  dateCreatedScheduling: PropTypes.objectOf(typeof date),
  operator: PropTypes.string,
  phoneNumber: PropTypes.string,
  creditValue: PropTypes.phoneNumber,
  pointValue: PropTypes.phoneNumber
}

export default AboutMobileRechargeSchedule



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/AboutMobileRechargeSchedule/AboutMobileRechargeSchedule.js